import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { client } from 'utilities/db';
import { useFetchColors } from 'hooks/resourceHooks';
import {
  useFetchRecipeMixtures,
  useFetchRecipes
} from 'hooks/recipes/useRecipesHook';
import { ThemeTabs } from 'components/tabs';
import { ButtonDropdown } from 'components/select/button';
import { TextField } from 'components/input';
import { Toasts } from 'components/toasts';
import { Ikon } from 'assets/icons';
import styles from './index.module.css';
import { RenderIf } from 'utilities/helpers';
import { PrimaryButton } from 'components/button';
import ImgEmptyRecipe from 'assets/Images/empty_recipe.png';
import { useStore } from 'store';
import { useCountry } from 'contexts/CountryContext';
import { AccessDenied } from 'components/acess-denied';

export const EngineeringRecipe = ({ onChangeStep, onChangeModifiers }) => {
  const { user, branch } = useStore((state) => state);
  const { currencySymbol } = useCountry();
  const recipePermission = user?.role?.permissions?.find(
    (permission) =>
      permission?.slug === 'recipe_engineering' &&
      permission?.module_slug === 'recipes'
  );
  const branchId = branch?.id;
  const locationId = branch?.location_id;

  const [searchField, setSearchField] = useState('');
  const { mutate, isLoading, isSuccess, isError, error, data } = useMutation(
    (userData) => {
      return client.post(
        isEdit ? `/category/update/${selectedCategory?.id}` : `/category/add`,
        userData
      );
    }
  );
  const { data: colorsList } = useFetchColors();
  const {
    refetch: refetchMenu,
    isLoading: menuIsLoading,
    error: menuError,
    data: recipesData = [],
    isSuccess: menuIsSuccess
  } = useFetchRecipes(branchId, user?.brand?.id);
  const { data: mixturesData } = useFetchRecipeMixtures(branchId);

  const navigate = useNavigate();
  const [selectedTypes, setselectedTypes] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [categoryText, setCategoryText] = useState('');
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [uploadImage, setUploadImage] = useState('');
  const [isActivate, setIsActivate] = useState(true);
  const [selectedCategory, setselectedCategory] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [linkedResturant, setLinkedResturant] = useState([]);

  useEffect(() => {
    const types = [...categoryOptions];
    types.push({
      name: categoryText,
      id: categoryText
    });
    setCategoryOptions(types);
  }, [categoryText]);

  useEffect(() => {
    if (!isSuccess) return;
    refetchMenu();
    onClose();
    setLinkedResturant([]);
  }, [isSuccess]);

  useEffect(() => {
    if (!user?.id) {
      navigate('/login');
      return;
    }
  }, [user]);

  const onEditClick = (val) => {
    // setIsEdit(true);
    // setselectedCategory(val);
    // setAdditionType('add');
    // setIsOpenModal(true);
    // setIsActivate(val?.is_active);
    // setLinkedResturant(
    //   brands
    //     ?.filter((item) => item.id === val?.brand_id)
    //     ?.map((item) => ({ label: item?.name, value: item?.id }))
    // );
  };
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const addMenu = (val) => {
    mutate({
      name: val?.name,
      brand_id: locationId,
      is_deleted: false,
      is_active: isActivate,
      color_id: 1,
      parent_id: null,
      image: uploadImage,
      description: val?.description,
      category_types: selectedTypes?.map((item) => ({
        name: item?.label,
        description: item?.label
      })),
      branch_ids:
        linkedResturant.length > 0
          ? linkedResturant.map((item) => item.value)
          : null,
      category_level: linkedResturant.length > 0 ? 'BRANCH' : 'BRAND'
    });
  };

  const onClose = () => {
    setIsOpenModal(false);
    setselectedCategory({});
    setIsEdit(false);
    setIsActivate(true);
    setLinkedResturant([]);
  };

  const panelRecipes = () => {
    return (
      <>
        <RenderIf
          isTrue={
            recipesData?.filter((item) =>
              item?.menu_item_name
                ?.toLowerCase()
                ?.includes(searchField?.toLowerCase())
            )?.length === 0
          }
        >
          <div style={{ marginTop: 24 }}></div>
          <div className={styles.emptyCard}>
            <h2>You currently have no items here</h2>
            <picture>
              <source srcSet={ImgEmptyRecipe} />
              <img src={ImgEmptyRecipe} alt="No Recipe" />
            </picture>
            <PrimaryButton
              onClick={() => {
                onChangeStep(2);
              }}
              disabled={recipePermission?.access?.create === false}
            >
              Add recipe
            </PrimaryButton>
          </div>
          <div style={{ marginTop: 24 }}></div>
        </RenderIf>
        <RenderIf
          isTrue={
            recipesData?.filter((item) =>
              item?.menu_item_name
                ?.toLowerCase()
                ?.includes(searchField?.toLowerCase())
            )?.length > 0
          }
        >
          <div className={styles.grid}>
            {recipesData
              ?.filter((item) =>
                item?.menu_item_name
                  ?.toLowerCase()
                  ?.includes(searchField?.toLowerCase())
              )
              ?.map((item, i) => (
                <div key={i} className={styles.card}>
                  <div>
                    <div>
                      <div className={styles.cardIcon}>
                        {item?.menu_item_name?.split(' ')?.[0]?.charAt(0)}
                        {item?.menu_item_name?.split(' ')?.[1]?.charAt(0)}
                      </div>
                      <h4 onClick={() => onEditClick(item)}>
                        <span className="ff_semi">
                          {item?.menu_item_name}
                          {/* {item?.modifier_name !== 'BASE'
                            ? ' - ' + item?.modifier_name
                            : ''} */}
                        </span>
                      </h4>
                    </div>
                    {/* <div>
                      <p>Price: {currencySymbol}{item?.price}</p>
                    </div> */}
                  </div>
                  <div>
                    <button
                      onClick={() => {
                        if (item?.id) {
                          navigate(`/recipe-engineering/add/${item?.id}`);
                          // onChangeStep(2);
                          return;
                        }

                        onChangeModifiers(item);
                      }}
                    >
                      <Ikon name="eye-view" />
                      View details
                    </button>
                  </div>
                </div>
              ))}
            {/* <button
              className={styles.card}
              onClick={(e) => {
                onChangeStep(4);
              }}
            >
              <div className={styles.hvCenter}>
                <div>
                  <div className={styles.cardPlusIcon}>
                    <Ikon name={`add-plus`} />
                  </div>
                </div>
              </div>
              <div>
                <div className={styles.asButton}>Add recipe</div>
              </div>
            </button> */}
          </div>
        </RenderIf>
      </>
    );
  };

  const panelMixture = () => {
    return (
      <>
        <RenderIf
          isTrue={
            mixturesData?.filter((item) =>
              item?.mixture_name
                ?.toLowerCase()
                ?.includes(searchField?.toLowerCase())
            )?.length === 0
          }
        >
          <div style={{ marginTop: 24 }}></div>
          <div className={styles.emptyCard}>
            <h2>You currently have no items here</h2>
            <picture>
              <source srcSet={ImgEmptyRecipe} />
              <img src={ImgEmptyRecipe} alt="No Mixture" />
            </picture>
            <PrimaryButton
              onClick={() => {
                onChangeStep(4);
              }}
              disabled={recipePermission?.access?.create === false}
            >
              Add mixture
            </PrimaryButton>
          </div>
          <div style={{ marginTop: 24 }}></div>
        </RenderIf>
        <RenderIf
          isTrue={
            mixturesData?.filter((item) =>
              item?.mixture_name
                ?.toLowerCase()
                ?.includes(searchField?.toLowerCase())
            )?.length > 0
          }
        >
          <div className={styles.grid}>
            {mixturesData
              ?.filter((item) =>
                item?.mixture_name
                  ?.toLowerCase()
                  ?.includes(searchField?.toLowerCase())
              )
              ?.map((item, i) => (
                <div key={i} className={styles.card}>
                  <div>
                    <div>
                      <div className={styles.cardIcon}>
                        {item?.mixture_name?.split(' ')?.[0]?.charAt(0)}
                        {item?.mixture_name?.split(' ')?.[1]?.charAt(0)}
                      </div>
                      <h4 onClick={() => onEditClick(item)}>
                        <span className="ff_semi">{item?.mixture_name}</span>
                      </h4>
                    </div>
                  </div>
                  <div>
                    <button
                      onClick={() => {
                        console.log('mixtures clicked: ', item);
                        if (item?.id) {
                          navigate(
                            `/recipe-engineering/update-mixture/${item?.id}`,
                            {
                              state: item
                            }
                          );
                          return;
                        }
                      }}
                    >
                      <Ikon name="eye-view" />
                      {'View details'}
                    </button>
                  </div>
                </div>
              ))}
            <button
              className={styles.card}
              onClick={(e) => {
                onChangeStep(4);
              }}
              disabled={recipePermission?.access?.create === false}
            >
              <div className={styles.hvCenter}>
                <div>
                  <div className={styles.cardPlusIcon}>
                    <Ikon name={`add-plus`} />
                  </div>
                </div>
              </div>
              <div>
                <div className={styles.asButton}>Add mixture</div>
              </div>
            </button>
          </div>
        </RenderIf>
      </>
    );
  };

  useEffect(() => {
    if (!isError) return;
    Toasts.error(
      error?.response?.data?.message ||
        'Some thing went wrong please try again later'
    );
  }, [isError]);

  return (
    <>
      <RenderIf isTrue={recipePermission?.access?.read === false}>
        <AccessDenied />
      </RenderIf>
      <RenderIf isTrue={recipePermission?.access?.read === true}>
        {/* <div className="mt_40"></div> */}
        <div className="flex item_space_btn pt_20">
          <div>
            <h2
              style={{
                fontSize: '24px',
                fontWeight: '800'
              }}
            >
              Recipe Engineering
            </h2>
            <h5 className="mt_4">Manage and create recipes</h5>
          </div>

          <div>
            <PrimaryButton
              onClick={(e) => onChangeStep(4)}
              disabled={recipePermission?.access?.create === false}
            >
              Add Mixture
            </PrimaryButton>
          </div>
        </div>
        <div className="mt_32"></div>
        <ThemeTabs
          tabs={[{ label: 'Recipes' }, { label: 'Mixture' }]}
          panels={[{ content: panelRecipes() }, { content: panelMixture() }]}
          isSearch={
            mixturesData?.length === 0 && recipesData?.length === 0 ? (
              <div />
            ) : (
              <TextField
                placeholder="Search"
                onChange={(e) => setSearchField(e?.target?.value)}
                value={searchField}
              />
            )
          }
        />
        <div className="mt_40"></div>
      </RenderIf>
    </>
  );
};
